import React from 'react';
import './style.css';
import {Link} from 'react-router-dom';
import {CONFIG_URL, LinkApp, PATH} from '../../constants';
import IMG from "../../constants/image";
import FooterMobile from "./FooterMobile";
import IconText from "../Common/Text/IconText";
import {isMobile} from "react-device-detect";
import {ENV} from "../../network/config";

const Footer = () => {

    return (
        <>
            <FooterMobile/>
            <footer className="hidden md:block text-gray-600 bg-white shadow-lg">
                {isMobile && <FooterMobile/>}
                {!isMobile && <div className="hidden md:block">
                    <div
                        className="bg-[#197D55] flex flex-col md:flex-row gap-8 py-5 md:py-10 px-[10px] md:px-[150px] justify-between">

                        <div className="flex flex-col gap-[14px] items-start md:w-[50%] text-white">
                            <Link className='cursor-pointer' to={PATH.HOME}>
                                <img src={IMG.logoLight} alt="Logo" className="mb-4 w-[200px] rounded-[5px]"/>
                            </Link>
                            <p className="text-white text-xs mb-4">
                                FUTA FuNong là cầu nối giúp bà con nông dân có thể đưa sản phẩm của mình tới tay người
                                tiêu dùng một cách dễ dàng và thuận tiện. Hợp tác cùng FUTA FuNong, bà con nông dân được
                                hỗ trợ 100% chi phí sàn cùng với chi phí vận chuyển tối ưu để đạt được hiệu quả cao
                                nhất.
                            </p>
                            <div className='flex gap-1'>
                                <IconText
                                    iconClass='w-6 h-6'
                                    icon={IMG.icon.building}
                                    text="CÔNG TY CP THƯƠNG MẠI ĐIỆN TỬ VẬN THÔNG - MST: 0314712128"
                                />
                            </div>
                            <div className='flex gap-1'>
                                <IconText
                                    iconClass='w-6 h-6'
                                    icon={IMG.icon.locationLight}
                                    text="218 Đề Thám, Phường Phạm Ngũ Lão, Quận 1, TP.Hồ Chí Minh"
                                />
                            </div>
                            <div className='flex gap-1'>
                                <IconText
                                    iconClass='w-6 h-6'
                                    icon={IMG.icon.phoneLight}
                                    text="033 959 6667"
                                />
                            </div>
                        </div>
                        <div className='flex flex-col text-white text-xs'>
                            <h3 className="text-xs font-bold mb-4 uppercase">HỖ TRỢ KHÁCH HÀNG</h3>
                            <Link className='mb-2' to={`${ENV.FUNONG_DOMAIN}/dieu-khoan-su-dung`} target='_blank'>
                                Điều khoản sử dụng
                            </Link>
                            <Link className='mb-2' to={`${ENV.FUNONG_DOMAIN}/chinh-sach-bao-mat`} target='_blank'>
                                Chính sách bảo mật
                            </Link>
                            <Link to={`${ENV.FUNONG_DOMAIN}/ban-hang`} target='_blank'>
                                Bán hàng trên FUTA FuNong
                            </Link>
                            <h3 className="hidden md:block text-xs font-bold my-4 uppercase">Tải ứng dụng FUTA
                                FuNong</h3>
                            <Link to={`${LinkApp.IOS}`} target='_blank' className='pb-4 hidden md:block'>
                                <img
                                    className="w-[200px] md:w-[148px] bg-white rounded-[5px]"
                                    src={IMG.ios}
                                    alt="futaBusLines"/>
                            </Link>
                            <Link to={`${LinkApp.ANDROID}`} target='_blank' className='hidden md:block'>
                                <img
                                    className="w-[200px] md:w-[148px] bg-white rounded-[5px]"
                                    src={IMG.android}
                                    alt="futaBusLines"/>
                            </Link>
                        </div>
                        <div className='flex flex-col text-white gap-[15px]'>
                            <h3 className="text-xs font-bold uppercase">Đối tác vận chuyển</h3>
                            <Link to={CONFIG_URL.FUTA_BUSLINES} target='_blank'>
                                <div className='p-1 cursor-pointer'>
                                    <img
                                        className="w-[200px] md:w-[148px] bg-white rounded-[5px]"
                                        src={IMG.futaBusLines}
                                        alt="futaBusLines"/>
                                </div>
                            </Link>
                            <Link to={CONFIG_URL.FUTA_EXPRESS} target='_blank'>
                                <div className='p-1 cursor-pointer'>
                                    <img
                                        className="w-[200px] md:w-[148px] bg-white rounded-[5px]"
                                        src={IMG.futaExpress}
                                        alt="futaExpress"/>
                                </div>
                            </Link>
                            <h3 className="text-xs font-bold uppercase">Đối tác thanh toán</h3>
                            <Link to={CONFIG_URL.GOOPAY} target='_blank'>
                                <div className='rounded-md cursor-pointer'>
                                    <img
                                        className="w-[200px] h-[68px]"
                                        src={IMG.goopayLogo}
                                        alt="goopayLogo"/>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>}
            </footer>
        </>
    );
};

export default Footer;
